export default "__VITE_ASSET__BcykkB$q__"